// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionAwards_institution-awards__j8sTb .InstitutionAwards_award__aBr3K {
  margin-bottom: 25px;
}
.InstitutionAwards_institution-awards__j8sTb .InstitutionAwards_award__aBr3K .InstitutionAwards_section-title__Kymca {
  color: var(--dark-grey);
  font-weight: 500;
  font-size: 14px;
}
.InstitutionAwards_institution-awards__j8sTb .InstitutionAwards_award__aBr3K .InstitutionAwards_title__qoMZF:hover {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
@media only screen and (max-width: 480px) {
  .InstitutionAwards_institution-awards__j8sTb .InstitutionAwards_section-title__Kymca {
    text-decoration: underline;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/InstitutionAwards/InstitutionAwards.module.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AACI;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;AACN;AACI;EACE,WAAA;EACA,0BAAA;EACA,eAAA;AACN;AAEE;EACE;IACE,0BAAA;EAAJ;AACF","sourcesContent":[".institution-awards {\n  .award {\n    margin-bottom: 25px;\n    .section-title {\n      color: var(--dark-grey);\n      font-weight: 500;\n      font-size: 14px;\n    }\n    .title:hover {\n      color: blue;\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n  @media only screen and (max-width: 480px) {\n    .section-title {\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-awards": `InstitutionAwards_institution-awards__j8sTb`,
	"award": `InstitutionAwards_award__aBr3K`,
	"section-title": `InstitutionAwards_section-title__Kymca`,
	"title": `InstitutionAwards_title__qoMZF`
};
export default ___CSS_LOADER_EXPORT___;
